/**
 * v16.17 Phase C.31 — Tournament tab slug (Vietnamese, no diacritics).
 *
 * Map giữa tab CODE (dùng trong state/logic) và tab SLUG (dùng trong URL).
 * URL trước:  /athlete/tournaments/{tid}?tab=livestream&match=bk-1
 * URL sau:    /athlete/tournaments/{tid}/livestream?match=bk-1
 * URL slug:   /athlete/tournaments/pickleball-mo-rong-2026/su-kien
 */

// code (internal) → slug (URL VN không dấu)
export const TAB_CODE_TO_SLUG = {
  events: "su-kien",
  matches: "tran-dau",
  livestream: "livestream",
  timeline: "dien-bien",
  gallery: "thu-vien",
};

// slug → code (dùng khi parse URL)
export const TAB_SLUG_TO_CODE = Object.entries(TAB_CODE_TO_SLUG).reduce(
  (acc, [code, slug]) => {
    acc[slug] = code;
    return acc;
  },
  {},
);

/** Get tab CODE from URL slug or code (backward compat). Returns null if invalid. */
export function resolveTabCode(input) {
  if (!input) return null;
  const s = String(input).toLowerCase();
  // Nếu đã là code hợp lệ → return luôn.
  if (TAB_CODE_TO_SLUG[s]) return s;
  // Ngược lại thử tra slug → code.
  return TAB_SLUG_TO_CODE[s] || null;
}

/** Get URL slug from tab CODE. Default → 'su-kien' nếu code không hợp lệ. */
export function tabCodeToSlug(code) {
  if (!code) return TAB_CODE_TO_SLUG.events;
  return TAB_CODE_TO_SLUG[code] || TAB_CODE_TO_SLUG.events;
}

/** Danh sách slug hợp lệ (dùng cho route matcher). */
export const VALID_TAB_SLUGS = Object.values(TAB_CODE_TO_SLUG);
